import { apiService } from '@services/api.service.ts';
export interface ContactMessagePayload {
  name: string;
  email: string;
  phone?: string;
  message?: string;
}

const contactService = apiService.injectEndpoints({
  endpoints: build => ({
    sendMessage: build.mutation<any[], any>({
      query: values => {
        return {
          method: 'POST',
          url: '/account/register/',
          body: values
        };
      },
      transformResponse: (response, meta): any => {
        if (meta?.response?.ok) {
          return response;
        }
      }
    }),
    contactForm: build.mutation<any, ContactMessagePayload>({
      query: values => ({
        method: 'POST',
        url: '/account/contact/form/',
        body: values
      }),
      transformResponse: (response, meta): any => {
        if (meta?.response?.ok) {
          return response;
        }
        return response;
      }
    })
  })
});

export const { useSendMessageMutation, useContactFormMutation } =
  contactService;
